import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetVehiclesCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IGetVehiclesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'vehicleOwners/{ownerId}/vehicles';

  public override setParameters(parameters: IGetVehiclesCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId
    );
  }
}
export interface IGetVehiclesCommandParameters extends ICommandParameters {
  ownerId: string;
}
